import axios from 'axios';

const LoanFileService = {
  async createLoanFile(formValues) {
    const response = await axios.post('/loan-files', formValues);

    return response.data;
  },

  async getLoanFiles({ loanOfficerId, status, teamId, brokerId }) {
    const response = await axios.get('/loan-files', {
      params: {
        loanOfficerId,
        status,
        teamId,
        brokerId,
      },
    });

    return response.data;
  },

  async getLoanFile(id) {
    const response = await axios.get(`/loan-files/${id}`);

    return response.data;
  },

  async deleteLoanFile(id) {
    const response = await axios.delete(`/loan-files/${id}`);

    return response.data;
  },

  async updateLoanFile({ id, formValues }) {
    const response = await axios.put(`/loan-files/${id}`, formValues);

    return response.data;
  },

  async createLoanFileDocument({ id, formValues, file }) {
    const formData = new FormData();
    formData.append('file', file);

    Object.keys(formValues).forEach((key) => {
      if (key === 'date' && formValues[key]) {
        formData.append(key, formValues[key].toISOString());
      } else {
        formData.append(key, formValues[key]);
      }
    });

    const response = await axios.post(`/loan-files/${id}/documents`, formData);

    return response.data;
  },

  async getLoanFileDocuments(id) {
    const response = await axios.get(`/loan-files/${id}/documents`);

    return response.data;
  },

  async deleteLoanFileDocument({ id, documentId }) {
    const response = await axios.delete(
      `/loan-files/${id}/documents/${documentId}`
    );

    return response.data;
  },

  async getLoanFileDocument({ id, documentId }) {
    const response = await axios.get(
      `/loan-files/${id}/documents/${documentId}`
    );

    return response.data;
  },

  async updateLoanFileDocument({ id, documentId, formValues }) {
    const response = await axios.patch(
      `/loan-files/${id}/documents/${documentId}`,
      formValues
    );

    return response.data;
  },

  async getLoanFileBankStatementCollections(id) {
    const response = await axios.get(
      `/loan-files/${id}/bank-statement-collections`
    );

    return response.data;
  },
};

export default LoanFileService;
